module.exports = __webpack_public_path__ + "static/media/Property-workspace.fb833560.png";